import _ from "lodash";
import Promise from "bluebird";

import {
    addSinglePinterestPinSync,
    searchPinterestPinSyncsWithSearchCriteria
} from "../services/pinterest-pin-sync-data.service";
import {DESIGN_BATCH_SIZE} from "../constants/pinterest.constant";
import {getDesignsList, searchDesigns} from "../../design/services/design-data-service";

export {
    getCurrentPinterestPinSyncByType,
    generatePinterestPinsForDesigns,
}

const getCurrentPinterestPinSyncByType = async (type) => {
    let currentPinterestPinSync;
    const searchCriteriaList = [];
    searchCriteriaList.push({
        field: 'status',
        condition: '==',
        value: 'NEW'
    });

    searchCriteriaList.push({
        field: 'type',
        condition: '==',
        value: type
    });

    let shopifyProductPriceSyncResultList = await searchPinterestPinSyncsWithSearchCriteria(searchCriteriaList);

    if (_.isEmpty(shopifyProductPriceSyncResultList)) {
        const newPinterestPinSync: any = {
            status: 'NEW',
            type: type,
            totalVariants: 0
        }

        const newPinterestPinSyncResult: any = await addSinglePinterestPinSync(newPinterestPinSync);
        newPinterestPinSync.id = newPinterestPinSyncResult.id;
        currentPinterestPinSync = newPinterestPinSync;
    } else {
        currentPinterestPinSync = shopifyProductPriceSyncResultList[0];
    }

    return currentPinterestPinSync;
}

const generatePinterestPinsForDesigns = async (pinterestPinSync) => {
    console.log('pinterestPinSync', pinterestPinSync);

    const designIds = _.map(pinterestPinSync.designs, 'id');
    // create chunks of designIds to process in batches DESIGN_BATCH_SIZE
    const designIdChunks = _.chunk(designIds, DESIGN_BATCH_SIZE);

    const allDesigns = await fetchPinterestPinSyncDesigns(designIdChunks);


    const pinterestPinsList = preparePinterestPinsList(allDesigns);
}

const preparePinterestPinsList = async (allDesigns) => {
    let pinterestPinsList = [];

    console.log('allDesigns', allDesigns);

    _.forEach(allDesigns, (design) => {
        prepareSingleDesignPinterestPinsList(design, pinterestPinsList);
    });

    console.log('pinterestPinsList', pinterestPinsList);

    return pinterestPinsList;
}

const prepareSingleDesignPinterestPinsList = async (design, pinterestPinsList) => {
    const pinterestBoard = design?.parent + '/' + design?.quoteName;
    const contentList = design?.content?.contentList || [];
    const tags = design.designTags.join(', ') || '';

    _.forEach(design.variants, (designVariant, index) => {
        const description = contentList[index]?.productDescription || (design.label + ' | ' + tags);

        const pinterestPin = {
            title: design.label,
            description: description,
            board: pinterestBoard,
            url: design.url,
            image: design.image,
            tags: tags
        }

        pinterestPinsList.push(pinterestPin);
    });
}

const fetchPinterestPinSyncDesigns = async (designIdChunks) => {
    let allDesigns = [];

    await Promise.each(designIdChunks, async (designIds) => {
        console.log('designIds', designIds);

        const designs = await getDesignsList(designIds);
        allDesigns = allDesigns.concat(designs);
    });

    /*await Promise.each(designIdChunks.map(async (designIds) => {
        console.log('designIds', designIds);

        const searchCriteriaList = [];
        searchCriteriaList.push({
            field: 'id',
            condition: 'in',
            value: designIds
        });

        console.log('searchCriteriaList', searchCriteriaList);

        /!*const designs = await searchDesigns(searchCriteriaList);
        allDesigns = allDesigns.concat(designs);*!/
    }));*/

    return allDesigns;
}

const fetchShopifyProductsList = async (designIdChunks) => {
    let allShopifyProducts = [];

    await Promise.each(designIdChunks, async (designIds) => {
        console.log('designIds', designIds);

        const designs = await getDesignsList(designIds);
        allShopifyProducts = allShopifyProducts.concat(designs);
    });

    return allShopifyProducts;
}
